<ng-container class="preview-table">
	<div fxFlex fxLayout="column" class="card-section" [ngClass]="getContainerClass()">
		<span class="card-section-title">{{ 'incapacities' | translate }}</span>
		<ea-case-specification [caseDetails]="caseDetails"></ea-case-specification>
		<nc-datatable [id]="'incapacities'" [data$]="incapacities$" [columns]="columns$ | async" [filterConfig]="filterConfig"></nc-datatable>
	</div>
</ng-container>
